const STORAGE_PREFIX = "storefrontOrders";

const getStorageKey = (tenantId) =>
  `${STORAGE_PREFIX}:${String(tenantId || "").trim()}`;

const isUnexpired = (record, now = Date.now()) => {
  const expiresAt = Date.parse(record?.trackingTokenExpiresAt || "");
  return Boolean(
    record?.orderId &&
      record?.trackingToken &&
      Number.isFinite(expiresAt) &&
      expiresAt > now
  );
};

export const getSavedOrders = (tenantId) => {
  if (!tenantId || typeof localStorage === "undefined") return [];

  const key = getStorageKey(tenantId);
  try {
    const stored = JSON.parse(localStorage.getItem(key) || "[]");
    const orders = Array.isArray(stored)
      ? stored.filter((record) => isUnexpired(record))
      : [];
    if (orders.length !== stored?.length) {
      localStorage.setItem(key, JSON.stringify(orders));
    }
    return orders.sort(
      (a, b) => Date.parse(b.createdAt || "") - Date.parse(a.createdAt || "")
    );
  } catch {
    localStorage.removeItem(key);
    return [];
  }
};

export const saveTrackedOrder = (tenantId, order) => {
  if (!tenantId || !isUnexpired(order) || typeof localStorage === "undefined") {
    return null;
  }

  const normalized = {
    orderId: order.orderId,
    trackingToken: order.trackingToken,
    trackingTokenExpiresAt: order.trackingTokenExpiresAt,
    createdAt: order.createdAt || new Date().toISOString(),
  };
  const remaining = getSavedOrders(tenantId).filter(
    (saved) => String(saved.orderId) !== String(normalized.orderId)
  );
  localStorage.setItem(
    getStorageKey(tenantId),
    JSON.stringify([normalized, ...remaining])
  );
  return normalized;
};

export const getSavedOrder = (tenantId, orderId) =>
  getSavedOrders(tenantId).find(
    (order) => String(order.orderId) === String(orderId)
  ) || null;
